import className from 'classnames/bind';
import { ChevronLeft, ChevronRight, Grid, PostsEntry } from '@/components';
import styles from './PostsList.module.scss';

let cx = className.bind(styles);

const updateQuery = (previousResult, { fetchMoreResult }) => {
	return fetchMoreResult.posts?.edges?.length ? fetchMoreResult : previousResult;
};

export function PostsList({ fetchMore, posts, pagination, postPerPage, cols = 4, articleHeadingStyle, imageSizes }) {
	return (
		<>
			<Grid colCount={cols} className={cx(['posts-grid'])} style={{ '--gridCols': `${cols}` }}>
				{posts?.edges.length > 0 ? posts.edges?.map((post) => <PostsEntry key={post.node.id} title={post.node.title} date={post.node.date} author={post.node.author} uri={post.node.uri} featuredImage={post.node.featuredImage} articleHeadingStyle={articleHeadingStyle} imageSizes={imageSizes} />) : <p>No posts found</p>}
			</Grid>
			{pagination && (posts?.pageInfo?.hasPreviousPage || posts?.pageInfo?.hasNextPage) && (
				<div className={cx(['pagination'])}>
					{posts?.pageInfo?.hasPreviousPage && (
						<button
							className={cx(['prev-posts'])}
							onClick={() => {
								fetchMore({
									variables: {
										first: null,
										after: null,
										last: postPerPage,
										before: posts?.pageInfo.startCursor || null,
									},
									updateQuery,
								});
							}}>
							<ChevronLeft />
							<span className="sr-only">Previous Posts</span>
						</button>
					)}
					{posts?.pageInfo?.hasNextPage && (
						<button
							className={cx(['next-posts'])}
							onClick={() => {
								fetchMore({
									variables: {
										first: postPerPage,
										after: posts?.pageInfo.endCursor || null,
										last: null,
										before: null,
									},
									updateQuery,
								});
							}}>
							<ChevronRight />
							<span className="sr-only">Next Posts</span>
						</button>
					)}
				</div>
			)}
		</>
	);
}
